// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"6b3e2c90","245":"f432edff","800":"236f04b1","943":"21ad097b"}[chunkId] + ".chunk.js";
};